import { axiosClient } from "services/axios";

import { AddPrintTemplateValues, GetPrintTemplatesParams } from "../types";

export function getPrintTemplates({
  page = 1,
  pageSize = 1000,
  doc_operation = null,
}: GetPrintTemplatesParams) {
  return axiosClient.get("documents/templates", {
    params: { page, pageSize, doc_operation },
  });
}

export function deletePrintTemplate(params: { template_id: number }) {
  return axiosClient.delete("documents/template", { params });
}

export function addPrintTemplate(data: AddPrintTemplateValues) {
  return axiosClient.post("documents/template", data);
}

export function addPrintTemplateFile(formData) {
  return axiosClient.post("documents/template/file", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
